import { Component, OnInit } from '@angular/core';
import { EditorService } from '../../shared/services/editor.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import Gleap from 'gleap';
import { ThemingService } from 'src/app/shared/services/theming.service';
import { SocialAuthService } from '@abacritt/angularx-social-login';


@Component({
    selector: 'app-setting',
    templateUrl: './setting.component.html',
    styleUrls: ['./setting.component.scss'],
})

export class SettingComponent implements OnInit {
    wbSite : any = ''
    wordPressUserName : any = ''
    password2 : any = ''
    intregtedAccount : any = []
    panelOpenState2 = false


    uid: string = ""
    userData: any = {}
    initials: string = "";
    circleColor: string = "";
    password: string = "";
    cPassword: string = "";
    private colors = [
        '#EB7181', // red
        '#468547', // green
        '#FFD558', // yellow
        '#3670B2', // blue
    ];
    isDisabled = true;
    theme: boolean = false;

    constructor(private editorServie: EditorService,    private socialAuth:SocialAuthService,
        private themingService:ThemingService, private toastr: ToastrService, private cookieServ: CookieService, private router: Router) { 
        this.themingService.getThemeName().subscribe((res: any) => {
            this.theme = res;
          })
    }


    ngOnInit(): void {
        this.themingService.pingThemeName();
        this.uid = this.cookieServ.get("uid");
        // this.uid = "u-0b41030a-fa26-11ed-84d6-bb490d2813ff";
        if (!this.uid || !localStorage.getItem('auth_token')) {
            this.router.navigate([`login`])
        } else {
            this.getUserProfile();
        }

    }
    getUserProfile() {
        this.editorServie.getUserprofile({ uid: this.uid }).subscribe(res => {
            this.userData = res.userDetails[0];
            const randomIndex = Math.floor(Math.random() * Math.floor(this.colors.length));
            this.circleColor = this.colors[randomIndex];
            this.createInititals();
        })

    }
    createInititals(): void {
        // let initials = "";
        // let name = this.userData.first_name + this.userData.last_name
        // for (let i = 0; i < name.length; i++) {
        //     if (name.charAt(i) === ' ') {
        //         continue;
        //     }

        //     if (name.charAt(i) === name.charAt(i).toUpperCase()) {
        //         initials += name.charAt(i);

        //         if (initials.length == 2) {
        //             break;
        //         }
        //     }
        // }
        this.initials = this.userData.first_name.concat(" ",this.userData.last_name)
        .split(" ")
        .map((n:any) => n[0])
        .join("").toUpperCase();
        }
    resetPassword() {
        if (this.password == '' || this.cPassword == '') {
            this.toastr.error('Password and confirm password should not be empty')
        } else if ((this.password !== '' && this.cPassword !== '') && this.password !== this.cPassword) {
            this.toastr.error('Password and confirm password not matching')
        }
        else if ((this.password !== '' && this.cPassword !== '') && this.password == this.cPassword) {
            this.editorServie.resetPass({
                "uid": this.uid,
                "password": this.password,
                "cpassword": this.cPassword
            }).subscribe(res => {
                if (!!res && !!res.success)
                    this.logOut()
                    this.toastr.success(res.success)
            })
        }
    }

    logOut(){
        Gleap.clearIdentity();
        this.socialAuth.signOut();
        localStorage.clear()
        sessionStorage.clear()
        this.cookieServ.delete("uid", "/", window.location.hostname, true, "None");
        this.cookieServ.delete("userName", "/", window.location.hostname, true, "None");
        this.cookieServ.delete("email", "/", window.location.hostname, true, "None");
        this.cookieServ.delete("plan", "/", window.location.hostname, true, "None");
        this.cookieServ.delete("first_name", "/", window.location.hostname, true, "None");
        this.cookieServ.delete("last_name", "/", window.location.hostname, true, "None");
        this.router.navigate(['login']);
      }

      // async addAccount(){
      //   if(!this.wordPressUserName){
      //     this.toastr.error('Please fill out WordPress Site Domain')
      //     return
      //   }
      //   if(!this.password2){
      //     this.toastr.error('Please fill out WordPress Application Password')
      //     return
      //   }
      //   if(!this.wbSite){
      //     this.toastr.error('Please fill out WordPress Username')
      //     return
      //   }
      //   if(!!this.wordPressUserName && !!this.password2 && !!this.wbSite && !!this.uid){
      //     if(!!this.wbSite && this.wbSite != "" ){
      //       this.wbSite = this.getDomain(this.wbSite,true)
      //     }
      //     let Obj = {
      //       username:this.wordPressUserName,
      //       password:this.password2,
      //       website:this.wbSite,
      //       uid:this.uid
      //     }
      //     let _Obj : any = {
      //       password:this.password2,
      //       username:this.wordPressUserName,
      //       website:this.wbSite,
      //       title:"title",
      //       content:"test",
      //   }

      //   this.editorServie.checkCrediantial(_Obj).subscribe((res:any)=>{
      //     if(res?.success){
      //       console.log(res);
      //         let Obj = {
      //           username:this.wordPressUserName,
      //           password:this.password2,
      //           website:this.wbSite,
      //           uid:this.uid
      //         }
      //         this.editorServie.addIntregratedAccount(Obj).subscribe((res:any)=>{
      //           if(res){
      //               this.wbSite = ''
      //               this.wordPressUserName = ''
      //               this.password2 = ''
      //             this.getIntreGretedAccount()
      //             this.toastr.success('account added successfully')
      //           }else{
      //             this.toastr.success('getting error when intgerated account')
      //           }
      //         })
      //     }else{
      //       this.toastr.error('please provide valid crediantial.')
      //     }
      //   })
      //   }
    
      // }
    
      // getIntreGretedAccount(){
      //   this.wbSite = ''
      //   this.wordPressUserName = ''
      //   this.password2 = ''
      //   this.editorServie.getIntregratedAccount({uid:this.uid}).subscribe((res)=>{
      //     this.intregtedAccount = res.account
      //   })
      // }
    
      // deleteWordPressAccount(accountId:any){
      //     this.editorServie.deleteIntregratedAccount({accountId:accountId}).subscribe((res)=>{
      //       if(res){
      //         this.getIntreGretedAccount()
      //         this.toastr.success('Account Disconnect successfully')
      //       }
      //     })
      // }
    
      getDomain(url:any, subdomain:any) {
        subdomain = subdomain || false;
    
        url = url.replace(/(https?:\/\/)?(www.)?/i, '');
    
        if (!subdomain) {
            url = url.split('.');
    
            url = url.slice(url.length - 2).join('.');
        }
    
        if (url.indexOf('/') !== -1) {
            return url.split('/')[0];
        }
    
        return url;
    }
    

}